export default function postOfflinePurchaseProof(formData: FormData) {
  return fetch(`${global.API_v1}/customer/payment/offline/proof`, {
    method: 'POST',
    headers: {
      "Authorization":`Bearer ${localStorage.getItem('authCustomerToken')}`,
    },
    body: formData,
  });
}
